import React from 'react';
import Title from '../../../../../shared/components/title/Title';
import EmptyState from '../../../../../shared/components/common/empty-state/EmptyState';
import { t } from 'i18next';
import { ProjectResponse } from '../../../../../shared/models/projects/ProjectResponse';
import { Button } from 'primereact/button';
import { ADD, PROJECTS, QUESTIONS } from '../../../../../shared/routes/path';
import LimitTooltipComponent from '../../../../../shared/components/common/limit-tooltip/LimitTooltipComponent';
import { AccountStatus } from '../../../../../shared/types/account/AccountStatus';
import { useNavigate } from 'react-router-dom';
import usePermission from '../../../../../shared/hooks/global/UsePermission';

interface ProjectPreviewEmptyStateProps {
  isSuperAdmin: boolean;
  firmNameOrg: string;
  accountStatus: AccountStatus;
  currentProject: ProjectResponse | null;
  canManage: boolean;
  projectId: string | undefined;
  demoVersion: string | null;
}

export const ProjectPreviewEmptyState: React.FC<ProjectPreviewEmptyStateProps> = ({
  isSuperAdmin,
  firmNameOrg,
  accountStatus,
  currentProject,
  canManage,
  projectId,
  demoVersion,
}) => {
  const navigate = useNavigate();
  const projectsAccess = usePermission('PROJECTS');

  if (!currentProject) {
    return <></>;
  }

  const getAddProjectButton = (currentProject: ProjectResponse) => {
    if (['BLOCKED'].includes(accountStatus) || (!!demoVersion && !isSuperAdmin)) {
      return <></>;
    }

    // Gość nie dodaje pytań — pusty stan zostaje samym komunikatem.
    if (!projectsAccess.write) {
      return <></>;
    }

    return (
      <>
        <Button
          className={`btn btn--sm ${!canManage ? 'btn--disabled-tooltip-color' : ''}`}
          onClick={() => {
            if (canManage) {
              navigate(`${PROJECTS}/${projectId}${QUESTIONS}${ADD}`);
            }
          }}
          label={t('addNewQuestion')}
          id="add-prompt"
        />
        {!canManage && <LimitTooltipComponent id="add-prompt" direction="bottom" />}
      </>
    );
  };

  const emptyStateData = {
    title: t(isSuperAdmin ? 'emptyStateProjectPrompts' : 'emptyStateProjectPromptsNoPermission'),
    imageClassName: 'img--project',
    children: getAddProjectButton(currentProject),
  };

  return (
    <div className=" page-content">
      <div className="page-box">
        <Title isBaseCategory={false} title={firmNameOrg} />
        <EmptyState emptyStateData={emptyStateData} />
      </div>
    </div>
  );
};
